import ButtonIcon from "components/ButtonIcon";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { ModalWrapper } from "./styled"
import { FaTrashAlt, FaCheck, FaShare } from "react-icons/fa";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { authSelector, tourOrderSelector } from "redux/selector";
import { tourOrderActions } from "redux/slice/tourOrder";
import { role } from "common/general";
import { get_day_of_time } from "utils";
import ShowToast from "utils/ShowToast";


const Modal = ({ selectedId, showModal, hidden, callback }) => {
    const tourOrderState = useSelector(tourOrderSelector)
    const authState = useSelector(authSelector)

    const dispatch = useDispatch()
    const data = useMemo(() => {
        if (tourOrderState.tourOrderAdmin.length > 0) {
            return tourOrderState.tourOrderAdmin.find(item => item.id === selectedId)
        }
        return {}
    }, [selectedId, tourOrderState.tourOrderAdmin])

    const checkStatus = () => {
        if (data) {
            if (data.status === 0 && parseInt(get_day_of_time(new Date(), new Date(data?.departure_day))) >= 0) return true
            if (data.status === 1) return true
        }
        return false
    }

    const getStatus = () => {
        if (data) {
            if (data.status === 0 && parseInt(get_day_of_time(new Date(), new Date(data?.departure_day))) >= 0) return "Xác nhận"
            if (data.status === 1) return "Kết thúc"
        }
        return ""
    }
    const handleUpdate = () => {
        if (data) {
            if (!data.staff_id || data.staff_id === authState.currentUser.user.account_id) {
                if (data.status === 1 && parseInt(get_day_of_time(new Date(), new Date(data?.departure_day))) > 0) {
                    ShowToast("error", "Không thể kết thúc tour sớm hơn thời gian bắt đầu!")
                } else {
                    const payload = {
                        status: data.status === 0 ? 1 : 2,
                        staff_id: authState.currentUser.user.account_id,
                        customer_email: data.customer_email
                    }
                    if (!tourOrderState.loading)
                        dispatch(tourOrderActions.updateTourAdmin({ id: data.id, data: payload, callback }))
                    hidden()
                }
            } else {
                ShowToast("error", "Bạn không phải là người xác nhận tour này!")
            }
        }
    }

    const handleRemove = () => {
        if (data) {
            if (!tourOrderState.loading)
                dispatch(tourOrderActions.removeTour({ id: data.id, callback }))
            hidden()
        }
    }



    return (
        <ModalWrapper>
            <div className="amep">
                <div className='amep_overlay'
                    onClick={hidden}
                    style={
                        showModal ? {
                            transform: 'translateY(0%)',
                            opacity: 1
                        } : {
                            transform: 'translateY(-120%)',
                            opacity: 0
                        }
                    }
                ></div>
                <div className="amep_container"
                    style={
                        showModal ? {
                            transform: 'translateY(0%)',
                            opacity: 1
                        } : {
                            transform: 'translateY(-120%)',
                            opacity: 0
                        }
                    }
                >
                    <div className="text-black s-18 bb-grey2-1 medium text-center pb-5">Cập nhật tour order</div>
                    <div className="flex-space px-15 mt-20">
                        <div>
                            {
                                authState.role === role.ADMIN &&
                                <ButtonIcon classButton="action-danger" icon={<FaTrashAlt />} onClick={handleRemove}>Xóa</ButtonIcon>
                            }
                        </div>
                        <div className="flex">
                            {
                                data && checkStatus() &&
                                <ButtonIcon classButton="action-danger-1 mr-10" icon={<FaCheck />} onClick={handleUpdate}>{getStatus()}</ButtonIcon>
                            }
                            <ButtonIcon classButton="action-primary" icon={<FaShare />}
                                onClick={hidden}
                            >Thoát</ButtonIcon>
                        </div>
                    </div>
                </div>
            </div>
        </ModalWrapper>
    );
}

export default Modal;